import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfService, RunTimeDataService } from '@leandredev/common_ng';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { filter } from 'rxjs/internal/operators/filter';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';

@Injectable({
  providedIn: 'root'
})
export class IsSignedInGuard implements CanActivate {
  constructor(private router: Router, protected confService: ConfService, protected runTimeDataService: RunTimeDataService) {}

  public canActivate(): Observable<boolean> {
    return this.confService.initCon.pipe(
      filter((data) => data),
      mergeMap(() => {
        if (this.confService.connected) {
          return of(true);
        } else {
          this.router.navigate(['/login']);
          return of(false);
        }
      })
    );
  }
}
